// @flow

import React from 'react';
import { connect } from 'react-redux';
import Search from './search';
import {
  getUiSetting,
  setUiSetting,
} from '../../../store/uiStore';

type OwnProps = {|
  name: string,
  error?: boolean,
  valid?: boolean,
  onSubmit: Function,
  placeholder?: string,
  buttonText: string,
  defaultValue?: ?string,
  value?: string,
|};

type StateProps = {|
  searchValue: string | boolean,
|};

type DispatchProps = {|
  setSearchValue: (value: string) => void,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
  ...DispatchProps,
|};

const SearchContainer = ({
  searchValue, defaultValue, setSearchValue, ...rest
}: Props) => {
  const value = typeof searchValue !== 'string' ? defaultValue : searchValue;

  return (
    <Search
      {...rest}
      onInputChange={setSearchValue}
      value={value || ''}
    />
  );
};

SearchContainer.defaultProps = {
  error: false,
  valid: false,
  placeholder: '',
  defaultValue: null,
  value: '',
};

const mapStateToProps = (state: *, { name }: OwnProps): StateProps => ({
  searchValue: getUiSetting(state, `search-${name}`),
});

const mapDispatchToProps = (dispatch: Function, ownProps: OwnProps): DispatchProps => ({
  setSearchValue: value => dispatch(setUiSetting(`search-${ownProps.name}`, value)),
});

export default connect<Props, OwnProps, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(SearchContainer);
